import styled from "styled-components";

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: ${props => (props.overflowFix ? "auto" : "unset")};
`;

export const MainContent = styled.div`
  flex: 1 1 auto;
  position: relative;
  overflow-y: auto;
`;

export const StickyHeader = styled.div`
  flex: 0 0 auto;
  width: 100%;
`;

export const StickyFooter = styled.div`
  flex: 0 0 auto;
  width: 100%;
  z-index: 1;
`;



// WEBPACK FOOTER //
// ./app/styled-components/Layout.js